import { convertMinutesToHours } from 'utils';
import { LightningIcon } from 'components/Icon';

import styles from './EventStats.module.scss';

export type EventStatsProps = {
  eventName: string;
  reason: string;
  duration: number;
  maxViewers: number;
  handRaises: number;
  totalSpeakers: number;
  onGoBackToChannel?(): void;
};

const EventStats = ({
  eventName,
  reason,
  duration,
  handRaises,
  maxViewers,
  totalSpeakers,
  onGoBackToChannel
}: EventStatsProps) => (
  <div className={styles.container}>
    <div className={styles.info}>
      <h3 className={styles.name}>{eventName}</h3>
      <p className={styles.reason}> {reason}</p>
    </div>

    <div className={styles.stats}>
      <div className={styles.title}>
        <LightningIcon />
        <span>Event stats</span>
      </div>

      <ul className={styles.list}>
        <li>
          <p className={styles.item}>
            <span className={styles.label}>Duration:</span>
            <b className={styles.value}> {convertMinutesToHours(duration || 0)}</b>
          </p>
        </li>
        <li>
          <p className={styles.item}>
            <span className={styles.label}>Max viewers:</span>
            <b className={styles.value}>{maxViewers}</b>
          </p>
        </li>
        <li>
          <p className={styles.item}>
            <span className={styles.label}>Hand-raises:</span>
            <b className={styles.value}>{handRaises}</b>
          </p>
        </li>
        <li>
          <p className={styles.item}>
            <span className={styles.label}> Guests on stage:</span>
            <b className={styles.value}>{totalSpeakers}</b>
          </p>
        </li>
      </ul>
    </div>

    <button type="button" className={styles.back} onClick={onGoBackToChannel}>
      Go to my channel
    </button>
  </div>
);

export default EventStats;
